import { z } from 'zod';

export const ActivityStatuses = [
  'ERUPTION_OCCURRED',
  'ERUPTION_ONGOING',
  'HEIGHTENED_UNREST',
  'DECREASED_ACTIVITY',
  'LAST_VA_EMISSION',
  'RE-SUSPENDED_VA',
  'UNKNOWN',
  'NIL',
] as const;
export const ActivityStatusZod = z.enum(ActivityStatuses);
export type ActivityStatus = z.infer<typeof ActivityStatusZod>;

export const ActivityZod = z.discriminatedUnion('status', [
  z.object({ status: ActivityStatusZod.exclude(['LAST_VA_EMISSION']) }),
  z.object({
    status: ActivityStatusZod.extract(['LAST_VA_EMISSION']),
    lastVaEmission: z.string().datetime(),
  }),
]);
export type Activity = z.infer<typeof ActivityZod>;

export const ActivityStatusText: Record<ActivityStatus, string> = {
  ERUPTION_OCCURRED: 'Eruption occurred',
  ERUPTION_ONGOING: 'Eruption ongoing',
  HEIGHTENED_UNREST: 'Heightened unrest',
  DECREASED_ACTIVITY: 'Decreased unrest',
  LAST_VA_EMISSION: 'Last volcanic ash emission...',
  'RE-SUSPENDED_VA': 'Re-suspended volcanic ash',
  NIL: 'Nil',
  UNKNOWN: 'Unknown',
};

export const ActivityStatusIwxxmText: Record<ActivityStatus, string> = {
  ERUPTION_OCCURRED: 'ERUPTION_OCCURRED',
  ERUPTION_ONGOING: 'ERUPTION_ONGOING',
  HEIGHTENED_UNREST: 'HEIGHTENED_UNREST',
  DECREASED_ACTIVITY: 'DECREASED_ACTIVITY',
  LAST_VA_EMISSION: 'LAST_VA_EMISSION',
  'RE-SUSPENDED_VA': 'RE-SUSPENDED_VA',
  NIL: 'NIL',
  UNKNOWN: 'UNKNOWN',
};

export const ActivityStatusTacText: Record<ActivityStatus, string> = {
  ERUPTION_OCCURRED: 'ERUPTION OCCURRED',
  ERUPTION_ONGOING: 'ERUPTION ONGOING',
  HEIGHTENED_UNREST: 'HEIGHTENED UNREST',
  DECREASED_ACTIVITY: 'DECREASED UNREST',
  LAST_VA_EMISSION: 'LAST VA EMISSION',
  'RE-SUSPENDED_VA': 'RE-SUSPENDED VA',
  NIL: 'NIL',
  UNKNOWN: 'UNKNOWN',
};
